export default {
    trendcall: 'Trendcall',
    macrotrends: 'Macro-trends',
    industries: 'Industries'
}
